import { EnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { DokaIdentityLoginService } from '@doka/identity-login';
import { OAuthService } from 'angular-oauth2-oidc';

// @doka/identity-login never renews the access token itself, so refresh it (via refresh token) before it expires.
export function provideTokenRefresh(): EnvironmentProviders {
  return provideAppInitializer(async () => {
    const loginService = inject(DokaIdentityLoginService);
    const oauthService = inject(OAuthService);

    // A token received before the login is restored makes the login service navigate to the root url,
    // so only start refreshing once it is ready.
    await loginService.ready();
    oauthService.setupAutomaticSilentRefresh({}, 'access_token');
  });
}
